export default __webpack_public_path__ + "static/media/DOR_2021.9db03c3c.m4v";